export const V3IconGreenDot = () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="5" fill="#8BD100" stroke="#F4F4F6" strokeWidth="2" />
</svg>